import React, { useState, useEffect } from 'react';
import { Modal, Typography, Button, Spin, Form, Input, Select } from 'antd';
import { withRouter } from 'react-router-dom';
import { getConfluenceSpaces } from '../../skills_action';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
const { Text } = Typography;
const { Option } = Select;
const BookEmojiModal = (props) => {
  const dispatch = useDispatch();
  const spaces = useSelector((state) => state.skills.confluence_spaces);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('confluence');
  const [errMsg, setErrMsg] = useState('');
  const [title, setTitle] = useState('');
  const [labels, setLabels] = useState('');
  const [content, setContent] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [selectedSpace, setSelectedSpace] = useState('');
  const [selectedPage, setSelectedPage] = useState('');
  const [pages, setPages] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  useEffect(() => {
    dispatch(getConfluenceSpaces(props.match.params.wId));
  }, []);

  const getFooter = () => {
    let initialFooter = [
      <Button key='close' onClick={props.handleClose}>
        Close
      </Button>,
    ];
    if (type === 'add' || type === 'update') {
      initialFooter.push(
        <Button
          type='primary'
          loading={loading}
          disabled={loading}
          key='submit'
          onClick={handleOk}
        >
          Submit
        </Button>
      );
    }
    return initialFooter;
  };
  const createConfluenceDoc = async (values) => {
    try {
      const createConfDoc = await axios.post(
        `/bot/api/w/${props.match.params.wId}/wiki/createConfluenceDocument`,
        values
      );
      if (createConfDoc && createConfDoc.data.success === false) {
        setErrMsg(createConfDoc.data.message);
      } else {
        setErrMsg('');
        setType('success');
        setSuccessMsg({ url: createConfDoc.data.url, title, type: 'create' });
      }
    } catch (err) {
      setErrMsg(err);
      console.error(err);
    }
  };

  const updateConfluenceDoc = async (values) => {
    try {
      const findPage = pages.find((el) => el.value === values.selectedPage);
      values.url = findPage.url;
      values.title = findPage.name;
      const updateDoc = await axios.post(
        `/bot/api/w/${props.match.params.wId}/wiki/updateConfluenceDocument`,
        values
      );
      if (updateDoc && updateDoc.data.success === false) {
        setErrMsg(updateDoc.data.message);
      } else {
        setErrMsg('');
        setType('success');
        // console.log(updateDoc.data)
        setSuccessMsg({
          type: 'update',
          url: updateDoc.data.url,
          title: updateDoc.data.title,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        if (type === 'add') {
          createConfluenceDoc(values);
        } else {
          updateConfluenceDoc(values);
        }
      })
      .catch((info) => {
        console.error('Validate Failed:', info);
      });
  };

  const onSearch = async (val) => {
    try {
      const pages = await axios.get(
        `/bot/api/w/${props.match.params.wId}/wiki/getConfluencePages?search=${val}`
      );
      const data = pages.data;

      setPages(data.pages);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getData = setTimeout(() => onSearch(searchValue), 400);
    return () => clearTimeout(getData);
  }, [searchValue]);

  const handleAddConfluence = async () => {
    try {
      setType('add');
      setLoading(true);
      const result = await axios.post(
        `/bot/api/w/${props.match.params.wId}/wiki/parseBookEmojiString`,
        props.record
      );

      const data = result.data;

      if (data.success) {
        setErrMsg('');
        setTitle(data.title);
        setContent(data.content);
        setLabels(data.keywords);
      } else if (data.message && data.type == 'permission') {
        setType('error');
        setErrMsg(data.message);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };

  const handleUpdateConfluence = async () => {
    try {
      setType('update');
      setLoading(true);
      const result = await axios.post(
        `/bot/api/w/${props.match.params.wId}/wiki/parseBookEmojiString`,
        props.record
      );

      const data = result.data;
      if (data.success) {
        setErrMsg('');
        setLabels(data.keywords);
      } else if (data.message && data.type == 'permission') {
        setType('error');
        setErrMsg(data.message);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);

      console.error(err);
    }
  };

  return (
    <div>
      <Modal
        onOk={handleOk}
        visible={true}
        title={
          type === 'add'
            ? 'Add to confluence'
            : type === 'update'
            ? 'Update Confluence'
            : 'Confluence'
        }
        onCancel={props.handleClose}
        footer={getFooter()}
      >
        {loading ? (
          <div style={{ textAlign: 'center' }}>
            <Spin />
          </div>
        ) : (
          <>
            {type === 'add' && (
              <Form
                form={form}
                layout='vertical'
                name='form_in_modal'
                initialValues={{
                  title,
                  content,
                  labels,
                  confluencespace: selectedSpace,
                }}
              >
                {errMsg && errMsg != 'Too many page labels max limit is 20' && (
                  <>
                    <Text style={{ color: 'red' }}>{errMsg}</Text>
                    <br />
                  </>
                )}
                <Form.Item
                  name='title'
                  label='Page Title'
                  rules={[
                    {
                      required: true,
                      message: 'Page Title is required',
                    },
                  ]}
                >
                  <Input onChange={(e) => setTitle(e.target.value)} />
                </Form.Item>
                <Form.Item
                  name='confluencespace'
                  label='Choose Confluence Space'
                  rules={[
                    {
                      required: true,
                      message: 'Confluence Space is required',
                    },
                  ]}
                >
                  <Select onChange={(el) => setSelectedSpace(el)} allowClear>
                    {spaces.map((el) => (
                      <Option value={el.key}>{el.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                {errMsg && errMsg == 'Too many page labels max limit is 20' && (
                  <>
                    <Text style={{ color: 'red', paddingBottom: 2 }}>
                      {errMsg}
                    </Text>
                    <br />
                  </>
                )}
                <Form.Item
                  name='labels'
                  label='Page Labels'
                  rules={[
                    {
                      required: true,
                      message: 'Page Labels are required',
                    },
                  ]}
                >
                  <Input.TextArea
                    onChange={(event) => setLabels(event.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  name='content'
                  label='Page Content'
                  rules={[
                    {
                      required: true,
                      message: 'Page Content is required',
                    },
                  ]}
                >
                  <Input.TextArea
                    onChange={(e) => setContent(e.target.value)}
                  />
                </Form.Item>
              </Form>
            )}
            {type === 'update' && (
              <>
                <Form
                  form={form}
                  layout='vertical'
                  name='form_in_modal'
                  initialValues={{
                    labels,
                    selectedPage,
                  }}
                >
                  {errMsg && (
                    <>
                      <Text style={{ color: 'red' }}>{errMsg}</Text>
                      <br />
                    </>
                  )}
                  <Form.Item
                    name='selectedPage'
                    label='Choose Confluence page'
                    rules={[
                      {
                        required: true,
                        message: 'Confluence Page is required',
                      },
                    ]}
                  >
                    <Select
                      allowClear={true}
                      showSearch
                      placeholder='start typing to search for Confluence Page'
                      optionFilterProp='children'
                      onChange={(val, e) => {
                        setSelectedPage(val);
                      }}
                      onSearch={(val) => setSearchValue(val)}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {(pages || []).map((el) => (
                        <Option value={el.value}>{el.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name='labels'
                    label='Page Labels'
                    rules={[
                      {
                        required: true,
                        message: 'Page Labels are required',
                      },
                    ]}
                  >
                    <Input.TextArea
                      onChange={(event) => setLabels(event.target.value)}
                    />
                  </Form.Item>
                </Form>
              </>
            )}
            {type === 'confluence' && (
              <>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Text>Add this message thread to a new Confluence page</Text>
                  <Button onClick={handleAddConfluence}>
                    Add to Confluence
                  </Button>
                </div>
                <br />
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <Text>
                    Update an existing Confluence page labels with keywords from
                    this message
                  </Text>
                  <Button onClick={handleUpdateConfluence}>
                    Update Confluence
                  </Button>
                </div>
              </>
            )}
            {type === 'success' && (
              <>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Text>
                    <>
                      Confluence Page{' '}
                      <a target='_blank' href={successMsg.url}>
                        {successMsg.title}
                      </a>{' '}
                      successfully{' '}
                      {successMsg.type === 'update' ? 'updated' : 'created'}.
                    </>
                  </Text>
                </div>
              </>
            )}
            {type === 'error' && (
              <>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <>
                    <Text style={{ color: 'red' }}>{errMsg}</Text>
                    <br />
                  </>
                </div>
              </>
            )}
          </>
        )}
      </Modal>
    </div>
  );
};
export default withRouter(BookEmojiModal);
